import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText } from '@mui/material';


export const CreateQuizModal = ({ showAdd, handleCloseAdd, lngsltd, newCourseID, setNewCourseID, courseData, courseNameError,
    newTitle, setNewTitle, quizTitleError, newDescription, setNewDescription, handleSave }) => {
    return (
        <Dialog open={showAdd} onClose={handleCloseAdd} fullWidth>
            <DialogTitle style={{ backgroundColor: '#efedf0' }}>
                {lngsltd["Add Quiz"]}
            </DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal" error={Boolean(courseNameError)}>
                    <InputLabel >
                       {`${lngsltd["Course"]}*`}
                    </InputLabel>
                    <Select
                        id="coursename"
                        value={newCourseID}
                        onChange={(e) => setNewCourseID(e.target.value)}
                        fullWidth
                        label={`${lngsltd["Course"]}*`}
                    >
                        <MenuItem value="" disabled>
                            {lngsltd["Select Course Name"]}
                        </MenuItem>
                        {courseData.map((data) => (
                            <MenuItem key={data.courseID} value={data.courseID}>
                                {data.courseName}
                            </MenuItem>
                        ))}
                    </Select>
                    {courseNameError && <FormHelperText>{courseNameError}</FormHelperText>}
                </FormControl>

                <TextField
                    margin="normal"
                    fullWidth
                    id="newTitle"
                    label={`${lngsltd["Title"]} *`}
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.target.value)}
                    error={Boolean(quizTitleError)}
                    helperText={quizTitleError}
                />

                <TextField
                    margin="normal"
                    fullWidth
                    id="newDescription"
                    label={lngsltd["Description"]}
                    multiline
                    rows={3}
                    value={newDescription}
                    onChange={(e) => setNewDescription(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleSave}>
                    {lngsltd["Add"]}
                </Button>
                <Button variant="outlined" color='error' onClick={handleCloseAdd}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    );
}